import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	canContactPrompt: {
		id: 'project-create-importer-upload-flow.common.utils.feedback-collector.can-contact-prompt',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>.',
		description: 'Prompt asking user if they give consent to be contacted',
	},
	submitButtonLabel: {
		id: 'project-create-importer-upload-flow.common.utils.feedback-collector.submit-button-label',
		defaultMessage: 'Submit',
		description: 'Submit button label',
	},
});
